import axios, { AxiosInstance } from "axios";

const apiClient: AxiosInstance = axios.create({
  baseURL: window.location.origin + '/api',
  headers: {
    "Content-type": "application/json",
  },
});

export default apiClient;